export class AddonActivation {
  businessId: string;
  appId: string;
  addonId: string;
  activated: Date;
  deactivated: Date;
  lastUpdated: Date;

  constructor(data: any) {
    Object.assign(this, data);
    if (this.activated && !this.deactivated) {
      this.lastUpdated = this.activated;
    } else if (this.activated && this.deactivated) {
      this.lastUpdated = this.deactivated;
    }
  }
}
